
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import 'rxjs/add/observable/throw';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfigService } from './config.service';
import { BaseResponse } from '../models/dtos/base-response';



@Injectable({
  providedIn: 'root',
})
export class LeanNetworkService {
  


  public INTERNAL_SERVER_ERROR  = '05';
  public UNAUTHORIZED           = '10';
  public NOT_FOUND              = '20';

  constructor(
    private toastr        : ToastrService,
    private http          : HttpClient,
    private configService : ConfigService,
    private loading       : NgxSpinnerService) {
  }

  /*
  private _httpHeaders: HttpHeaders = new HttpHeaders({
    'Content-Type'                : 'application/json',
    'Access-Control-Allow-Origin' : '*'
  })
  private _httpOptions = {
    headers: this._httpHeaders,
    params: undefined,
    reportProgress: false,
    withCredentials: true
  }
*/

  public post(url: string, query: any): Promise<any> {

    let httpHeaders: HttpHeaders = new HttpHeaders({
      'Content-Type'                : 'application/json',
      'Access-Control-Allow-Origin' : '*'
    })
   // httpHeaders = httpHeaders.append('Authorization', 'Bearer ' + this.token);
    let httpOptions = {
      headers          : httpHeaders,
      params          : undefined,
      reportProgress  : false,
      withCredentials : true
    }
/*

    this._httpOptions.params = undefined;
    this._httpOptions.headers = this._httpHeaders;
*/

    this.loading.show();


    return new Promise((resolve, reject) => {
      this.http.post(this.configService.config.serverUrl + url, query, httpOptions).subscribe((response: any) => {
        this.loading.hide();
        if  (response.response.code === BaseResponse.ACCEPTED){
          resolve(response);
        } else  {
          let errorMessage = response.response.message;
          this.toastr.error(errorMessage);
          reject(response.response.message);
        }

      }, error => {
       this.loading.hide();
        let errorMessage = "Erreur réseau : Prière de vérifier votre connexion";
        this.toastr.error(errorMessage);
        reject(errorMessage);
      });
    });
  }

  public postToExternalServer(url: string, query: any): Promise<any> {
    this.loading.show();
    return new Promise((resolve, reject) => {
      this.http.post(url, query).subscribe((response: any) => {
        this.loading.hide();
        resolve(response);
      }, error => {
       this.loading.hide();
        this.toastr.error(error);
        reject(error);
      });
    });
  }

  getPdfFileAsBlob(url){
    let headers = new HttpHeaders()
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(url, { headers: headers, responseType: 'blob' });
  }
  
}

  /*
  public get(url: string, ): Promise<any> {
    this.loading.show();
    return new Promise((resolve, reject) => {
      this.http.get(this.backEndUri + url).subscribe((result: any) => {
        this.loading.hide();
        resolve(result);
      }, error => {
        this.loading.hide();
        reject(error);
      });
    });
  }


  private processErrorResponse(error: Response): string {
    if (error.status) {
      return this.extractHttpMessage(error.status.toString());
    }
    else
      return this.INTERNAL_SERVER_ERROR;
  }

  private extractHttpMessage(httpCode: string): string {
    switch (httpCode) {
      case '500': {
        return this.INTERNAL_SERVER_ERROR;
      }
      case '401': {
        return this.UNAUTHORIZED;
      }
      case '404': {
        return this.NOT_FOUND;
      }
      default:
        return this.INTERNAL_SERVER_ERROR;
    }
  }
*/
